const styles = {
  rightPannel: {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  sidebarMenu: {
    width: "30%",
    minWidth: 300,
    height: "100%",
    background: "#fff",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    transform: "translateX(100%)",
    transition: ".3s ease-out",
  },
  open: {
    transform: "translateX(0%)",
  },
};
export default styles;
